import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import clickOutside from 'react-click-outside';
import classnames from 'classnames';

import FinishedTypingTextBox from '../../../../../../../../components/Form/FinishedTyping';
import Spinner from '../../../../../../../../components/Spinner/';

import './UniversitySelector.scss';

class UniversitySelector extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedEntry: null,
      visible: false,
      firstTimeLoad: true,
      SearchFinished: false,
      value: props.defaultValue || {
        id: 0,
        name: ''
      },
    };

    this.handleFocus = this.handleFocus.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleChange = this.handleChange.bind(this); // When finished typing
    this.handleTyping = this.handleTyping.bind(this); // Every Key press
    this.handleClick = this.handleClick.bind(this);
    this.handleOnKey = this.handleOnKey.bind(this);
    this.respondOnChange = this.respondOnChange.bind(this); // Propogates Valuechange upstream
  }

  handleClickOutside(event) {
    this.setState({
      visible: false
    });
  }

  handleFocus(event) {
    this.setState({
      visible: true
    });
  }

  handleChange(event) { // When finished typing
    this.setState({
      firstTimeLoad: false,
      SearchFinished: false,
    });

    if (event.target.value.length > 0) {
      this.props.SearchUniversities.refetch({
        searchParam: event.target.value
      }).then(() => {
        this.setState({
          SearchFinished: true,
        });
      });
    }
  }

  handleTyping(event) { // Every key press
    const tempVal = {
      id: 99999,
      name: event.target.value,
    };
    this.setState({
      SearchFinished: false,
      value: tempVal,
    });
    this.respondOnChange(tempVal);
  }

  handleClick = newValue => (event) => {
    this.setState({
      visible: false,
      value: newValue,
      selectedEntry: null,
    });
    this.respondOnChange(newValue);
  }

  respondOnChange(val) {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          value: val
        }
      });
    }
  }

  handleOnKey(event) {
    switch (event.keyCode) {
      case 38: // Up
        event.preventDefault();
        if (this.state.selectedEntry !== null && this.state.selectedEntry !== 0) {
          this.setState({
            selectedEntry: (this.state.selectedEntry - 1),
          });
        }
        break;
      case 40: // Down
        event.preventDefault();
        if (this.state.selectedEntry === null || this.state.selectedEntry !== (this.props.maxDisplayLength - 1)) {
          if (this.state.selectedEntry !== null) {
            this.setState({
              selectedEntry: (this.state.selectedEntry + 1),
            });
          } else {
            this.setState({
              selectedEntry: 0,
            });
          }
        }
        break;
      case 13: // Enter
        event.preventDefault();
        this.textInput.blur();
        if (this.state.selectedEntry !== null) {
          this.handleClick(this.props.SearchUniversities.searchUniversitites[this.state.selectedEntry])();
        } else {
          this.handleClickOutside();
        }
        break;
      case 9: // Tab
        this.handleClickOutside();
        break;
    }
  }

  render() {
    const propsToOmit = ['onChange', 'onKeyDown', 'name', 'maxDisplayLength', 'SearchUniversities', 'defaultValue'];
    let spreadProps = {};

    Object.keys(this.props).forEach((value) => {
      if (propsToOmit.indexOf(value) === -1) {
        spreadProps[value] = this.props[value];
      }
    });

    const getWarning = () => {
      return (this.state.visible === false && this.state.value.name !== '' && this.state.value.id === 99999) ? (
        <p className='errorText'>Please select from the list</p>
      ) : null;
    };

    return (
      <div className='UniversitySelector'>
        {getWarning()}
        <FinishedTypingTextBox value={this.state.value.name} delay={300} name={this.props.name} onChange={this.handleChange}
          onFocus={this.handleFocus} currentValue={this.handleTyping} onKeyDown={this.handleOnKey}
          inputRef={(input) => { this.textInput = input }} {...spreadProps} />
        {(this.props.SearchUniversities.loading && this.state.firstTimeLoad === false) ? <Spinner /> : null}
        <ul className='UniversitySelector__SuggestionsWrap' style={(this.state.visible && this.state.SearchFinished) ? {} : { display: 'none' }}>
          {(this.props.SearchUniversities.searchUniversitites || []).slice(0, this.props.maxDisplayLength).map((uni, index) => (
            <li onClick={this.handleClick(uni)}
              className={classnames({
                'UniversitySelector__Suggestion': true,
                'UniversitySelector__Suggestion--selected': this.state.selectedEntry === index
              })}
              key={uni.id}>{uni.name}</li>
          ))}
        </ul>
      </div>
    );
  }
}

UniversitySelector.propTypes = {
  name: React.PropTypes.string.isRequired,
  maxDisplayLength: React.PropTypes.number,
  onChange: React.PropTypes.func
};

UniversitySelector.defaultProps = {
  maxDisplayLength: 4,
};

const SearchUniversityQuery = gql`
  query SearchUniversities($searchParam: String) {
    searchUniversitites(like: $searchParam) {
      id
      name
    }
  }
`;

export default graphql(SearchUniversityQuery, {
  name: 'SearchUniversities'
})(clickOutside(UniversitySelector));



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Education/components/UniversitySelector/index.js